import { render } from "./rate.md?vue&type=template&id=2ce67ae8"
import script from "./rate.md?vue&type=script&lang=js"
export * from "./rate.md?vue&type=script&lang=js"
script.render = render

export default script